import { Component } from '@angular/core';

@Component({
  selector: 'app-pagamento-completato',
  imports: [],
  templateUrl: './pagamento-completato.html',
  styleUrl: './pagamento-completato.css'
})
export class PagamentoCompletato {

}
